module.exports = __webpack_public_path__ + "media/images/recruit/common/webclip-icon-5d2281d86ffec5262138c82d4a65b908.png";